import LocationArea from '../models/location_area.model';

/**
 * Read a location area retrieved from the backend.
 * @param {Object} o
 * @return {LocationArea}
 */
function readLocationArea(o) {
  return new LocationArea(o.id, o.order, o.name);
}

export {
  readLocationArea
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/location_area.serializer.js